import { useStore } from 'effector-react'
import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { userOptionsStore } from '~/shared/api'
import { localeEnumOptions, OptionEnum } from '~/shared/config/constants'
import { LocaleEnum } from '~/shared/config/enums'
import { featureFlagModel } from '~/shared/lib/featureFlag'
import { DEFAULT_LOCALE, i18nModel } from '~/shared/lib/i18n'
import { AutocompleteInput, FormProvider } from '~/shared/ui/Form'

export function LocaleForm() {
  const featureFlag = useStore(featureFlagModel.$featureFlags)

  const defaultValues = useMemo(() => {
    const locale = userOptionsStore.locale || DEFAULT_LOCALE
    return {
      locale: localeEnumOptions.find(
        (localeOption) => localeOption.id === locale,
      ),
    }
  }, [])

  const form = useForm({
    defaultValues,
  })

  const handleLocaleChange = (locale: OptionEnum<LocaleEnum>) => {
    form.setValue('locale', locale)
    i18nModel.localeChangeFx({ locale: locale.id })
  }

  const filteredLocaleEnumOptions = useMemo(() => {
    return localeEnumOptions.filter((option) => {
      if (option.id === LocaleEnum.fr) {
        return !!featureFlag.visible_locale_france
      } else {
        return true
      }
    })
  }, [featureFlag.visible_locale_france])

  const selectedLocaleId = form.watch('locale')?.id

  return (
    <FormProvider form={form}>
      <AutocompleteInput
        startDecorator={
          <img
            src={`/icons/${selectedLocaleId}.png`}
            width='22px'
            alt='icon flag'
          />
        }
        name='locale'
        options={filteredLocaleEnumOptions}
        disableClearable
        size='sm'
        onChange={(_, value) =>
          handleLocaleChange(value as OptionEnum<LocaleEnum>)
        }
      />
    </FormProvider>
  )
}
